import BaseService from '@/services/base_service';

export default class ViaADMService extends BaseService {
    async list(params) {
        try {
            return await axios.get('/viaAdministracao/pesquisar', {
                params: params
            });
        } catch (e) {
            throw e;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/via_adm.js